import { LangApprover } from '../../../../constant/languange'
import { connect, mapStateToProps } from '../../../../helpers/Common'

const Approver = ({ redux, val }) => {
  return (
    <div className='table-responsive my-3 text-center'>
      <table className={`table table-sm ${redux.darkModeOn ? 'table-dark bg-dark' : ''}`}>
        <thead>
          <tr>
            <th scope='col' className='text-center align-middle p-2'>No.</th>
            <th scope='col' className='text-center align-middle p-2'>{LangApprover}</th>
          </tr>
        </thead>
        <tbody>
          {val.map((item, i) => (
            <tr key={i}>
              <td className={`${redux.darkModeOn ? 'border-secondary' : ''} p-2`}>{i + 1}</td>
              <td className={`${redux.darkModeOn ? 'border-secondary' : ''} p-2`}>{item.name}{item.group ? ` - ${item.group.name}` : ''}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default connect(mapStateToProps)(Approver)
